/*
*****************************************************************************
*File : vuetify.js
*Module : Dashboard Frontend
*Purpose : For specifying the dark and light
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
*/

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'

Vue.use(Vuetify)

const theme = {
  primary: '#4CAF50', //'#E91E63', 
  secondary: '#9C27b0',
  accent: '#9C27b0',
  info: '#00CAE3'
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },

  theme: {
    themes: {
      dark: theme,
      light: theme
    }
  }
})
